import { allowDevice, checkDriverRouteExistence, createUnscheduledDriverRoute, getPendingIncident } from "../api";
import syncStorage from "../../../syncStorage";
import { toast } from "../../Toasts";

export const checkIfLoadOutIsCompleted = async ({alertDispatch}) => {
    if (syncStorage.get("loadOutProcessCompleted")) {
        return true;
    } else {
        alertDispatch({
            type: "closeText",
            textArray: [
                "Load Out Process is not completed!",
            ],
        });
        return false;
    }
};

export const validateInspectionAccess = async ({
    api,
    station,
    alertDispatch,
    setIncidentPending,
    setMessage,
    setIsDeviceAllowed,
    history,
    closeModal,
    type,
}) => {
    try {
        if (type === "RTS" && !syncStorage.get("loadOutProcessCompleted")) {
            alertDispatch({
                type: "closeText",
                textArray: [
                    "Load Out Process is not completed!",
                ],
            });
            return false;
        }
        const insidentRes = await getPendingIncident(api, station);
        if (insidentRes?.incidentTask?.length > 0) {
            setIncidentPending(true);
            const insident = insidentRes.incidentTask[0];
            const msg = await insident?.messagesTwilioData[0]?.twilioMessage;

            setMessage(msg);
            let infoText = ["You are required to complete Incident form before starting Load Out."];

            if (insidentRes?.incidentTask?.length > 1) {
                infoText.push(`Total ${insidentRes?.incidentTask?.length} Incidents are pending`);
            }
            alertDispatch({
                type: "twoOptions",
                okText: "OK",
                cancelText: "CANCEL",
                textArray: infoText,
            });

            return false;
        }
        setIncidentPending(false);
        const deviceId = syncStorage.get("deviceId");
        if (!deviceId) {
            await toast({
                type: "error",
                title: "We are sorry 😥.",
                content: "Please register this device.",
            });
            history.push("/driver-phone-number");
            return false;
        }
        alertDispatch({
            type: "processing",
            textArray: [
                "We are checking if your device is enabled for Load Out.",
                "We are checking if you have an assigned Shift for today.",
                "Please wait",
            ],
        });
        let response = await allowDevice(api);
        setIsDeviceAllowed(response?.data?.isAllowed);
        if (response?.data?.message || (response.data && !response.data.isAllowed)) {
            alertDispatch({
                type: "closeText",
                textArray: [
                    response?.data?.message || "This device is not allowed for the Load Out Process.",
                    "Please contact your manager.",
                ],
            });
            return false;
        }
        let driverRouteExistenceResponse = await checkDriverRouteExistence(api);

        if (driverRouteExistenceResponse?.data?.driverRoute?.id) {
            syncStorage.set("driverRouteId", driverRouteExistenceResponse.data.driverRoute.id);
            return true;
        }

        if(driverRouteExistenceResponse?.response?.data) {
            let message = driverRouteExistenceResponse?.response?.data?.message;
            syncStorage.set("loadOutProcessCompleted", false);
            alertDispatch({
                type: "closeText",
                textArray: [message, "Please contact your manager."],
            });
            return false;
        }

        if (driverRouteExistenceResponse?.data?.message && !driverRouteExistenceResponse?.data?.success) {
            alertDispatch({
                type: "openYes&No",
                textArray: [
                    driverRouteExistenceResponse?.data?.message,
                    "Are you sure you want to proceed?",
                    "If you proceed, you will be assigned an Unscheduled Shift.",
                ],
            });
            return false;
        }

        if (driverRouteExistenceResponse?.data?.message && driverRouteExistenceResponse.data.success) {
            if (driverRouteExistenceResponse.data?.kickoffLog) {
                syncStorage.set(
                    "loadOutProcessCompleted",
                    !!driverRouteExistenceResponse.data.kickoffLog.processCompleted,
                );
            }
            closeModal();
            return true;
        }
    } catch (e) {
        await toast({
            type: "error",
            title: "We are sorry 😥.",
            content: `"Error in validation process: ${e}"`,
        });
        return false;
    }
};

export const okCallbackInspection = async ({ api, okText, alertDispatch, history, closeModal, vehicleId = 0 }) => {
    try {
        if (okText === "Close") {
            closeModal();
            return false;
        }

        alertDispatch({
            type: "processing",
            textArray: ["Please wait, we are processing your request."],
        });

        let unscheduledResponse = await createUnscheduledDriverRoute(api);

        if (unscheduledResponse?.response) {
            alertDispatch({
                type: "closeText",
                textArray: [unscheduledResponse?.response?.data?.message, "Please contact your manager."],
            });
            return false;
        }

        if (unscheduledResponse.data?.driverRoute?.id) {
            syncStorage.set("driverRouteId", unscheduledResponse.data.driverRoute.id);
            closeModal();
            if (Number.parseInt(vehicleId) > 0) {
                history.push("/inspection/" + vehicleId);
            } else {
                history.push("/inspection");
            }
            return true;
        } else {
            closeModal();
            await toast({
                type: "error",
                title: "We are sorry 😥.",
                content: `Error for Unscheduled Shift`,
            });
            return false;
        }
    } catch (e) {
        closeModal();
        await toast({
            type: "error",
            title: "We are sorry 😥.",
            content: `Error in creating an Unscheduled Shift.`,
        });
        return false;
    }
};
